export default class Iptu {
    constructor(
      _id,
      inscricao,
      obra,
      anoIPTU,
      parcela,
      bairro,
      createdAt,
      cidade,
      statusOcr,
      statusIntegracao,
      numDoc,
      logradouro,
      vencimento,
      codBarras,
      valorCobrado,
      acrescimos,
      deducoes,
      desconto,
      multa,
      valor,
      log_integracao,
      pathIPTU
    ) {
      this._id = _id,
      this.inscricao = inscricao,
      this.obra = obra,
      this.anoIPTU = anoIPTU,
      this.parcela = parcela,
      this.bairro = bairro,
      this.createdAt = createdAt ? new Date(createdAt) : "",
      this.cidade = cidade,
      this.statusOcr = statusOcr,
      this.statusIntegracao = statusIntegracao,
      this.numDoc = numDoc,
      this.logradouro = logradouro,
      this.vencimento = vencimento ? new Date(vencimento) : "",
      this.codBarras = codBarras,
      this.valorCobrado = valorCobrado,
      this.acrescimos = acrescimos,
      this.deducoes = deducoes ? deducoes : 0.0,
      this.desconto = desconto,
      this.multa = multa,
      this.valor = valor,
      this.log_integracao = log_integracao,
      this.pathIPTU = pathIPTU
    }
  }


// WEBPACK FOOTER //
// ./src/domain/automacaoFiscal/iptu/Iptu.js